// extracted by mini-css-extract-plugin
module.exports = {"sidebar__wrapper":"_3doItUkPRCMl","sidebar__link":"_18B7ULV8xMB7","sidebar__item":"_3y1he0i-pTSP"};